import React, { PropsWithChildren, useEffect, useState } from "react";
import { Form, Button, Input, Select, Space, DatePickerProps, DatePicker, TimePicker, InputNumber, Upload, Switch, UploadProps } from 'antd';
import FormItem, { mappedProps } from "./FormItem";
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Cascader } from "antd";
import type { GetProp, CascaderProps } from 'antd';
import { convertChar } from "../../Converter";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import * as ImageHelper from '../../ImageHelper';

type DefaultOptionType = GetProp<CascaderProps, 'options'>[number];

dayjs.extend(customParseFormat);
const dateFormat = 'YYYY-MM-DD';
export const dateFormatList = ['DD/MM/YYYY', 'DD-MM-YYYY'];


export function HiddenInput(fprops: any) {

    return (
        <FormItem item={fprops}>
            <span style={{ color: 'darkgray' }}>{fprops.defaultValue}</span>
        </FormItem>
    );
};

export const SwitchInput = (props: any) => {

    const { fieldKey, onDataChanged } = props

    const onChange = (checked: boolean) => {
        console.log(`switch to ${checked}`);
        console.log("DATA CHANGED SWITCH INPUT: ", props, fieldKey, checked)
        onDataChanged && onDataChanged(fieldKey, checked)
    };

    return (
        <Switch
            {...props}
            onChange={onChange}
        />
    )
}

export const SelectInput = (props: any) => {
    const { fieldKey, onDataChanged } = props

    const mode = props.mode ? props.mode : "default";

    var options = [{ key: "empty", label: "No Data" }];

    if (props && props.options && Array.isArray(props.options) && props.options.length > 0)
        options = props.options;

    // var defaultValue = options[0].key ? options[0].key : options[0];
    // if (props && props.defaultValue)
    //     defaultValue = props.defaultValue;
    // console.log("------- SELECT INPUT defaultValue: ", props);

    const handleChange = (value: any) => {
        // console.log("DATA CHANGED SELECT INPUT: ", props, fieldKey, value)
        onDataChanged && onDataChanged(fieldKey, value)
    };

    return <Select
        // mode={mode}
        // value="male"
        {...props}
        onChange={handleChange}
        onSelect={handleChange}
    >
    </Select>
}
export const CascaderInput = (props: any) => {
    const { fieldKey, onDataChanged } = props

    var options = [{ key: "empty", label: "No Data" }];

    if (props && props.options && Array.isArray(props.options) && props.options.length > 0)
        options = props.options;

    // var defaultValue = options[0].key ? options[0].key : options[0];
    // if (props && props.defaultValue)
    //     defaultValue = props.defaultValue;
    console.log("------- SELECT INPUT defaultValue: ", props);

    const handleChange = (value: string[]) => {
        console.log("DATA CHANGED SELECT INPUT: ", props, fieldKey, value)
        onDataChanged && onDataChanged(fieldKey, value)
    };
    const filter = (inputValue: string, path: DefaultOptionType[]) =>
        path.some(
            //convertChar(option.children.toLowerCase()).includes(convertChar(keyword.toLowerCase()))
            (option) => convertChar((option.label as string).toLowerCase()).indexOf(convertChar(inputValue.toLowerCase())) > -1,
        );


    return <Cascader
        // mode={mode}
        // value="male"
        {...props}
        options={options}
        onChange={handleChange}
        onSelect={handleChange}
        showSearch={{ filter }}
        onSearch={(value) => console.log(value)}
    >
    </Cascader>
}
export const TextInput = (props: any) => {
    const { inputStyle, fieldKey, onDataChanged } = props
    // console.log("TEXT INPUT PROPS: ", props)
    return <Input
        style={{
            borderRadius: '8px',
            border: 'none',
            background: '#FAFAFA',
            padding: '8px 16px',
            ...inputStyle,
            borderTop: '1px solid #F0F0F0',
        }}
        {...props}
        onChange={(e) => {
            console.log("DATA CHANGED: ", props, fieldKey, e.target.value)
            onDataChanged && onDataChanged(fieldKey, e.target.value)
        }}
    />

}

export function NumberInput(props: any) {
    const { inputStyle, fieldKey, onDataChanged } = props
    return (
        <InputNumber
            addonBefore={props.prefixSelector}
            style={{
                width: '100%',
                borderRadius: '8px',
                border: 'none',
                background: '#FAFAFA',
                padding: '8px 16px',
                ...inputStyle,
                borderTop: '1px solid #F0F0F0',
            }}
            {...props}
            onChange={(value) => {
                console.log("DATA CHANGED (number): ", props, fieldKey, value)
                onDataChanged && onDataChanged(fieldKey, value)
            }}
        />
    );
}

export const DatePickerInput = (props: any) => {
    const { inputStyle, fieldKey, onDataChanged } = props
    // console.log("DATE PICKER INPUT PROPS: ", props)

    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        console.log(date, dateString);
        onDataChanged && onDataChanged(fieldKey, date)
    };

    return <DatePicker
        style={{
            borderRadius: '8px',
            border: 'none',
            background: '#FAFAFA',
            padding: '8px 16px',
            ...inputStyle,
            borderTop: '1px solid #F0F0F0',
        }}
        {...props}
        // format={dateFormatList}
        onChange={onChange}
    />

}

export const TimePickerInput = (props: any) => {
    const { inputStyle, fieldKey, onDataChanged } = props
    console.log("Time PICKER INPUT PROPS: ", props)

    // const onChange: DatePickerProps['onChange'] = (date, dateString) => {
    //     console.log(date, dateString);
    //     onDataChanged && onDataChanged(fieldKey, date)
    // };

    const onChange = (time: Dayjs, timeString: string) => {
        console.log(time, timeString);
        onDataChanged && onDataChanged(fieldKey, time)
    };

    return <TimePicker
        style={{
            borderRadius: '8px',
            border: 'none',
            background: '#FAFAFA',
            padding: '8px 16px',
            ...inputStyle,
            borderTop: '1px solid #F0F0F0',
        }}
        {...props}
        onChange={onChange}
    />

}

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
export const UploadPictureInput = (props: any) => {
    const { inputStyle, fieldKey, onDataChanged, value } = props
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string>(value);

    useEffect(()=>{setImageUrl(value)}, [value])

    const handleChange: UploadProps['onChange'] = (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            console.log("UPload DONE")
            // Get this url from response in real world.
            ImageHelper.getBase64(info.file.originFileObj as FileType, (url: any) => {
                setLoading(false);
                onDataChanged && onDataChanged(fieldKey, url)
                setImageUrl(url);
            });
        }
        console.log("UPloading")
    };
    const onChangeFileHandler = (event: any) => {
        console.log('Upload event:', event);
        if (Array.isArray(event)) {
            return event;
        }

        console.log("FILE: ", event.file);

        // if (file && file.status === 'uploading') {
        //     console.log('UPLOADINGGGGGG:');
        setLoading(true);
        // }
        // if (file && file.status === 'done') {
        console.log('UPLOAD DONEEEEEEEEEE');
        // Get this url from response in real world.
        ImageHelper.getBase64(event.file.originFileObj, (imageUrl: any) => {
            onDataChanged && onDataChanged(fieldKey, imageUrl)
            console.log('UPLOAD DONEEEEEEEEEE: ', imageUrl);
            setImageUrl(imageUrl);
            setLoading(false);
        });
        // const reader = new FileReader();
        //}
        // console.log("file ----: ", file);
        // return event && event.fileList;
        return imageUrl;
    };

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    // const beforeUpload = (file: FileType) => {
    //     const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    //     if (!isJpgOrPng) {
    //         message.error('You can only upload JPG/PNG file!');
    //     }
    //     const isLt2M = file.size / 1024 / 1024 < 2;
    //     if (!isLt2M) {
    //         message.error('Image must smaller than 2MB!');
    //     }
    //     return isJpgOrPng && isLt2M;
    // };

    return (
        <Upload
            name={fieldKey}
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
            action={null}
            beforeUpload={ImageHelper.beforeUpload}
            {...inputStyle}
            {...props}
            onChange={onChangeFileHandler}
        >
            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt="avatar"
                    style={{
                        width: '100%',
                    }}
                />
            ) : (
                uploadButton
            )}
        </Upload>
    )
}

